/**
 * Features loader: serves the sidebar configuration from features.json
 * (the only features file; shared by all environments).
 */

import features from "./features.json";

// Type definition for the features structure
export interface SubmenuItem {
  id: number;
  key: string;
  name: string;
  submenuPath: string;
  /** Detail/form routes that should keep this submenu entry highlighted */
  relatedPaths?: string[];
  scrollable?: boolean;
}

export interface MainSidebarItem {
  id: number;
  key: string;
  title: string;
  image: string;
  menuColor: string;
  path?: string;
  pathPrefix: string;
  content?: Array<{
    contentTitle: string;
    importantBool: boolean;
    count: number;
  }>;
  submenu?: SubmenuItem[];
  scrollable?: boolean;
}

export interface SecondarySidebarItem {
  id: string;
  title: string;
  images?: string[];
  image: string;
  menuColor: string;
  disabled?: boolean;
  path: string;
}

export interface FeaturesConfig {
  mainSidebarItems: MainSidebarItem[];
  secondarySidebarItems: SecondarySidebarItem[];
}

/**
 * Gets the features configuration
 */
export const getFeatures = (): FeaturesConfig => {
  return features as FeaturesConfig;
};

// Export the features object based on environment
const Features = getFeatures();

export default Features;

